import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AppCard, AppModal } from '@/layout/AppComponents';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import * as currentPageAction from '../../../store/actions/currentPageAction';
import DocumentManagerSidebar from '../../../layout/screenSpecifics/Modules/DocumentManager/Sidebar/DocumentManagerSidebar';
import { axiosPath, path } from '@/routing/helpers/router';
import PublicationHome from '../../../layout/screenSpecifics/Modules/DocumentManager/PublicationHome';
import * as moduleAction from '../../../store/actions/moduleAction';

export default function ModuleDocumentManagerCoverScreen() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const moduleData = useSelector((s) => s?.module?.[moduleBridgeHex]?.moduleData);
  const permissionsLevel = useSelector(
    (s) => s.module[moduleBridgeHex]?.userBridge?.permissions?.level,
  );
  const [showPublicationAddModal, setShowPublicationAddModal] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(currentPageAction.empty());
    };
  }, []);

  // > LOAD MODULE DATA //
  const loadModuleData = async () => {
    dispatch(
      moduleAction.fetch(
        axiosPath('api_r_user_module_documentManager_getModuleData'),
        'moduleData',
        {
          moduleBridgeHex,
        },
      ),
    );
  };

  useEffect(() => {
    loadModuleData();
  }, []);
  // > LOAD MODULE DATA //

  // < STORE CALLS
  const loadModulePermissions = async () => {
    try {
      await dispatch(
        moduleAction.fetch(
          axiosPath('api_r_user_module_documentManager_getPermissions'),
          'permissions',
          {
            moduleBridgeHex,
            subType: 'permissions',
          },
        ),
      );
      await dispatch(
        moduleAction.fetch(
          axiosPath('api_r_user_module_documentManager_getPermissions'),
          'userBridge',
          {
            moduleBridgeHex,
            subType: 'userBridge',
          },
        ),
      );
    } catch (err) {}
  };

  useEffect(() => {
    loadModulePermissions();
  }, [moduleBridgeHex]);
  // < STORE CALLS

  return (
    <>
      <DocumentManagerSidebar activeRoute="user_module_documentManager_cover" />
      <BreadcrumbHandler
        paths={
          moduleData
            ? [
                {
                  name: `Repositorio ${
                    permissionsLevel === 0 ? '(ADMINISTRADOR)' : ''
                  }`,
                },
              ]
            : [{ name: '...' }]
        }
      />
      <main role="main" className="col-md-12 col-lg-12 px-md-4 mb-5">
        <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-0 pb-0 mb-0">
          <AppCard className="p-5">
            <div className="row">
              <div className="col-12 col-lg-6">
                <div
                  className="d-flex justify-content-center align-items-center pointer"
                  onClick={() => setShowPublicationAddModal(true)}
                >
                  <img width={110} src="/images/client/amia/aportacion.png" />
                  <h5 className="text-info ml-2">Realizar una aportación</h5>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div
                  className="d-flex justify-content-center align-items-center pointer"
                  onClick={() =>
                    navigate(
                      path({
                        name: 'user_module_documentManager_item_list',
                        params: {
                          moduleBridgeHex,
                          page: 1,
                          filtersHex: 0,
                        },
                      }),
                    )
                  }
                >
                  <img width={110} src="/images/client/amia/consultar.png" />
                  <h5 className="text-success ml-2">Consultar información</h5>
                </div>
              </div>
            </div>
          </AppCard>
          <AppModal
            show={showPublicationAddModal}
            title="Añadir publicación"
            size="xl"
            onClose={() => setShowPublicationAddModal(false)}
            backdrop="static"
          >
            <PublicationHome onClose={() => setShowPublicationAddModal(false)} />
          </AppModal>
        </div>
      </main>
    </>
  );
}
